import { render } from "./EditVehicle.vue?vue&type=template&id=67c45978"
import script from "./EditVehicle.vue?vue&type=script&lang=js"
export * from "./EditVehicle.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/cms.dealersgear.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__